import React from 'react';

// Array of place data
const placesData = [
    { id: 1, name: 'Mahabaleshwer', image: '/images/mahabaleshwer.jfif' },
    { id: 2, name: 'Mumbai', image: '/images/mumbai.jfif' },
    { id: 3, name: 'Goa', image: '/images/goa.jpg' },
    { id: 4, name: 'Lonavala', image: '/images/keyword/59.jpg' },
    { id: 5, name: 'Shirdi ', image: '/images/keyword/48.jpg' },
    { id: 6, name: 'Konkan Darshan', image: '/images/keyword/56.jpg' },
];

const PlaceSection = () => {
    return (
        <section className="place-section centred py-3">
            <div className="auto-container">
                <div className="sec-title mb_50">
                    <span className="sub-title">Top Places</span>
                    <h2>Top Places Visit with S9 Travels</h2>
                </div>
                <div className="row clearfix">
                    {placesData.map(place => (
                        <div className="col-lg-4 col-md-6 col-sm-12 place-block" key={place.id}>
                            <div className="place-block-one">
                                <div className="inner-box">
                                    <figure className="image-box">
                                        <img src={place.image} alt={place.name} />
                                    </figure>
                                    <span className="text">{place.name}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PlaceSection;
